module.exports = __webpack_public_path__ + "static/media/yunjiadajianshan1.bb49e9ad.webp";